// extracted by mini-css-extract-plugin
export var header = "_vh-1";
export var maskBottom = "_vh-6";
export var maskMiddle = "_vh-7";
export var maskTop = "_vh-5";
export var root = "_vh-0";
export var scrollDownButton = "_vh-3";
export var scrollDownButtonHidden = "_vh-4";
export var viewport = "_vh-2";